import type {
  SalesOrderItem,
  ReservationItem,
  ShipmentItem,
  CarrierRateItem,
  TrackingMilestone,
  CustomsDeclarationItem,
} from './types';

export const sampleSalesOrders: SalesOrderItem[] = [
  { id: '1', so_number: 'SO-2026-0812', customer_name: 'NexGen Data Labs', deal_id: 'DEAL-7801', status: 'ALLOCATED', order_date: new Date().toISOString(), total_amount: 7497 },
  { id: '2', so_number: 'SO-2026-0813', customer_name: 'Quantum Core Networks', deal_id: 'DEAL-7804', status: 'DRAFT', order_date: new Date().toISOString(), total_amount: 14200 },
];

export const sampleReservations: ReservationItem[] = [
  { id: '1', sku_id: 'HL-SRV-2000', quantity: 3, holder_type: 'SALES_ORDER', holder_id: 'SO-2026-0812', state: 'ACTIVE', expires_at: new Date(Date.now() + 48 * 3600000).toISOString() },
  { id: '2', sku_id: 'HL-OPT-100G', quantity: 20, holder_type: 'SALES_ORDER', holder_id: 'SO-2026-0813', state: 'BACKORDERED', expires_at: new Date(Date.now() + 72 * 3600000).toISOString() },
];

export const sampleShipments: ShipmentItem[] = [
  { id: '1', shipment_number: 'SHP-2026-901', so_id: 'SO-2026-0812', carrier: 'FedEx Express', tracking_number: 'FX-7890-1122-33', status: 'IN_TRANSIT', label_url: '#', shipped_at: new Date().toISOString() },
  { id: '2', shipment_number: 'SHP-2026-902', so_id: 'SO-2026-0810', carrier: 'UPS Worldwide', tracking_number: '1Z9999999999999999', status: 'DELIVERED', label_url: '#', shipped_at: new Date(Date.now() - 86400000).toISOString() },
];

export const sampleCarrierRates: CarrierRateItem[] = [
  { id: '1', carrier: 'FedEx Priority Overnight', service_level: 'Next Day 10:30 AM', transit_days: 1, rate: 84.50, is_fastest: true },
  { id: '2', carrier: 'UPS Ground Commercial', service_level: 'Day Definite 3-Day', transit_days: 3, rate: 24.80, is_cheapest: true },
  { id: '3', carrier: 'DHL Express Worldwide', service_level: 'International Priority', transit_days: 2, rate: 112.00 },
];

export const sampleTracking: TrackingMilestone[] = [
  { id: '1', tracking_number: 'FX-7890-1122-33', carrier: 'FedEx Express', destination: 'Austin, TX', status: 'OUT_FOR_DELIVERY', eta: 'Today 3:00 PM', last_location: 'Austin Hub (Sort Facility)' },
  { id: '2', tracking_number: '1Z-8921-2290-01', carrier: 'UPS Freight', destination: 'Seattle, WA', status: 'IN_TRANSIT', eta: 'Tomorrow 10:00 AM', last_location: 'Portland Interchange' },
];

export const sampleCustoms: CustomsDeclarationItem[] = [
  { id: '1', declaration_ref: 'DEC-2026-EU-019', destination_country: 'Germany (DE)', hs_code: '8517.62.0050', declared_value: 14800, duty_amount: 444, status: 'CLEARED' },
  { id: '2', declaration_ref: 'DEC-2026-JP-082', destination_country: 'Japan (JP)', hs_code: '8471.50.0150', declared_value: 32000, duty_amount: 0, status: 'SUBMITTED' },
];

export function adaptSalesOrder(raw: any): SalesOrderItem {
  if (!raw || typeof raw !== 'object') {
    return { id: Math.random().toString(), so_number: 'SO-0000', customer_name: 'Unknown', status: 'DRAFT', order_date: new Date().toISOString(), total_amount: 0 };
  }
  return {
    id: String(raw.id || Math.random()),
    so_number: String(raw.so_number || raw.number || 'SO-0000'),
    customer_name: String(raw.customer_name || raw.customer || 'Unknown Customer'),
    deal_id: raw.deal_id ? String(raw.deal_id) : undefined,
    status: String(raw.status || 'DRAFT'),
    order_date: String(raw.order_date || new Date().toISOString()),
    total_amount: Number(raw.total_amount ?? 0),
  };
}

export function adaptShipment(raw: any): ShipmentItem {
  if (!raw || typeof raw !== 'object') {
    return { id: Math.random().toString(), shipment_number: 'SHP-0000', so_id: '', carrier: 'Unknown', tracking_number: '', status: 'DRAFT', label_url: '#', shipped_at: new Date().toISOString() };
  }
  return {
    id: String(raw.id || Math.random()),
    shipment_number: String(raw.shipment_number || raw.number || 'SHP-0000'),
    so_id: String(raw.so_id || ''),
    carrier: String(raw.carrier || 'Standard'),
    tracking_number: String(raw.tracking_number || ''),
    status: String(raw.status || 'PENDING'),
    label_url: String(raw.label_url || '#'),
    shipped_at: String(raw.shipped_at || new Date().toISOString()),
  };
}
